/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_InactiveInputs */

const cs_requirements_inactive = /** @type {(inputs: Requirements_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neaktivní`)
};

const en_requirements_inactive = /** @type {(inputs: Requirements_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inactive`)
};

/**
* | output |
* | --- |
* | "Inactive" |
*
* @param {Requirements_InactiveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_inactive = /** @type {((inputs?: Requirements_InactiveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_InactiveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_inactive(inputs)
	return cs_requirements_inactive(inputs)
});